import { Button, Stack, Typography } from "@mui/material"
import React from "react"
import Image from "next/image"
import SuccessPayment from "public/images/icons/success_payment.svg"
import { convertToPersianDate } from "../../../utils/ConvertToPersianDate"
import { useRouter } from "next/router"
import Head from "next/head"
import Pages from "src/constants/pages"

export interface TrackPaymentProps {
  detail: any
}

const TrackPayment = ({ detail }: TrackPaymentProps) => {
  const router = useRouter()

  return (
    <>
      <Head>
        <title>بازپرداخت اقساط</title>
      </Head>

      <Stack spacing={2} mt={4} mb={1.5}>
        <Stack direction='row' justifyContent='center'>
          <Image src={SuccessPayment} alt='success_payment' width={300} />
        </Stack>
        <Typography variant='h4' fontWeight='bold' textAlign='center'>
          پرداخت شما با موفقیت انجام شد
        </Typography>
        <Typography variant='subtitle1' textAlign='center' sx={{ mt: 6 }}>
          کدرهگیری : {detail.trackingCode}
        </Typography>
        <Typography variant='subtitle1' textAlign='center'>
          تاریخ تراکنش: {detail.payDate ? convertToPersianDate(detail.payDate, "jYYYY/jMM/jDD") : ""}
        </Typography>
        <Stack direction='row' justifyContent='center'>
          <Button
            color='success'
            variant='contained'
            sx={{ borderRadius: "8px", px: 5 }}
            onClick={() => {
              router.push(Pages.Main)
            }}
          >
            بازگشت
          </Button>
        </Stack>
      </Stack>
    </>
  )
}

export default TrackPayment
